export default class StringDecoder {

    static decode(text) {
        return text
            ? text
                .replaceAll("&lt;figure", "<figure")
                .replaceAll("&lt;table", "<table")
                .replaceAll("&lt;tbody", "<tbody")
                .replaceAll("&lt;thead", "<thead")
                .replaceAll("&lt;tr", "<tr")
                .replaceAll("&lt;td", "<td")
                .replaceAll("&lt;th", "<th")
                .replaceAll("&lt;p", "<p")
                .replaceAll("&lt;strong", "<strong")
                .replaceAll("&lt;i", "<i")
                .replaceAll("&lt;h", "<h")
                .replaceAll("&lt;ul", "<ul")
                .replaceAll("&lt;ol", "<ol")
                .replaceAll("&lt;li", "<li")
                .replaceAll("&lt;a", "<a")
            : "";
    }
}